import React, {useEffect} from 'react'

const About = (props) => {
  useEffect(() => {
    props.showLoading()
    setTimeout(()=>{
        props.completeLoading()
    },100)
  }, [])
  document.title = props.title;
  return (
    <div>url is: {process.env.BASE_URL}</div>
  )
}

export default About